import { icon_basket } from '@gn-audio/icons';
import { Button } from '@gn-audio/jss-components';
import { JabraIcon } from '@gn-audio/jss-components';

import { Attribute } from 'api/productCatalogueApi';
import { usePageProduct } from 'common/PageProductContext/pageProductContext';
import useFallbackTranslation from 'utils/hooks/useFallbackTranslation';
import { getProductBuyPageUrl } from 'utils/productUtils';

export const ProductPageBuyButton = () => {
  const { attributes, productType, productName } = usePageProduct();
  const { t } = useFallbackTranslation();
  if (!attributes) return null;

  let productBuyPageUrl;

  if (productType === 'Family' && attributes) {
    productBuyPageUrl = `${attributes.pageUrl}/buy`;
  }
  if (productType === 'Group' && attributes?.attributes) {
    productBuyPageUrl = getProductBuyPageUrl(attributes.attributes as Attribute[]);
  }

  return (
    <Button
      aria-label={`${t('system.BuyNow')} ${productName}`}
      asLink={true}
      variant="primary"
      size="s"
      href={productBuyPageUrl}
      icon={<JabraIcon Icon={icon_basket} />}
      iconPlacement="right"
    >
      {t('system.BuyNow')}
    </Button>
  );
};
